<template>
  <div
    class="profile-panel-no-items"
    v-if="nftsList.total === 0 && !loadingNfts"
  >
    <h3 class="profile-panel-no-items-title">No Items Found</h3>
    <p class="profile-panel-no-items-text">
      {{ profilePanelNoItemsText }}
    </p>
    <p class="profile-panel-no-items-text">
      {{ profilePanelNoItemsTextLineTwo }}
    </p>
    <app-button
      buttonClass="create-nft-button"
      text="Create new NFT"
      @click.prevent="openMintingForm()"
    ></app-button>
  </div>
  <div class="profile-panel-body-content" v-if="nftsList.total > 0">
    <div v-for="(card, index) in nftDataList" :key="index">
      <nft-card
        :token="card"
        @click="$router.push({ name: 'NftDetails', params: { id: card.id } })"
      ></nft-card>
    </div>
  </div>
  <app-loader v-if="loadingNfts" :isGreen="true"></app-loader>
  <app-button
    v-if="nftsList.total >= nftDataList.length + 1 && !loadingNfts"
    text="Load more"
    class="load-more-button"
    @click.prevent="loadMore()"
  ></app-button>
</template>

<script>
import { useStore } from "vuex";
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import NftCard from "@/components/NftCard";
import AppButton from "@/elements/AppButton";
import AppLoader from "@/elements/AppLoader";
import useProfilePanels from "@/composables/useProfilePanels";
export default {
  components: {
    AppButton,
    AppLoader,
    NftCard,
  },
  setup() {
    const store = useStore();

    const {
      nftsList,
      profilePanelNoItemsText,
      profilePanelNoItemsTextLineTwo,
      loadMore,
      params,
      nftDataList,
      loadingNfts,
      toggleFilter,
    } = useProfilePanels(store);

    const router = useRouter();
    const openMintingForm = () => {
      store.dispatch("minting/resetState");
      store.dispatch("tagsValues/resetState");
      router.push("/");
    };

    const goToNftDetails = (nftId) => {
      router.push({ name: "NftDetails", params: { id: nftId } });
      store.dispatch("nftDetails/resetState");
    };
    onMounted(() => {
      store.dispatch("nftDetails/resetState");
      toggleFilter("filterCreated");
    });

    return {
      nftsList,
      profilePanelNoItemsText,
      profilePanelNoItemsTextLineTwo,
      openMintingForm,
      loadMore,
      params,
      nftDataList,
      loadingNfts,
      goToNftDetails,
    };
  },
};
</script>

<style lang="scss" scoped src="@/Common/Styles/profilePanels.scss"></style>
